/**
 * API de catálogo — Fases SDLC y preguntas BA
 */
import client from './client';

export const catalogApi = {
  // Phase catalog
  getPhases: () =>
    client.get('/catalog/phases'),

  updatePhase: (phaseId, hours, bufferPct) =>
    client.put(`/catalog/phases/${phaseId}`, { hours, buffer_pct: bufferPct }),

  // BA Questions
  getQuestions: (activeOnly = false) =>
    client.get('/catalog/ba-questions', { params: { active_only: activeOnly } }),

  createQuestion: (data) =>
    client.post('/catalog/ba-questions', data),

  updateQuestion: (questionId, data) =>
    client.put(`/catalog/ba-questions/${questionId}`, data),

  deleteQuestion: (questionId) =>
    client.delete(`/catalog/ba-questions/${questionId}`),
};
